import { Box, Skeleton } from '@myn/mui';

const HeaderSkeleton = () => {
  return (
    <Box gap={2} display="flex" flexDirection="column">
      <Skeleton
        variant="rounded"
        sx={{ marginTop: 1, marginBottom: 1, height: 16, width: 84 }}
      />
      <Skeleton variant="rounded" height={16} />
    </Box>
  );
};

export default HeaderSkeleton;
